import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Location\DeleteLocationController::deleteMethod
* @see app/Http/Controllers/Location/DeleteLocationController.php
* @route '/api/location/{location}'
*/
export const deleteMethod = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/location/{location}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Location\DeleteLocationController::deleteMethod
* @see app/Http/Controllers/Location/DeleteLocationController.php
* @route '/api/location/{location}'
*/
deleteMethod.url = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { location: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { location: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            location: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        location: typeof args.location === 'object'
        ? args.location.id
        : args.location,
    }

    return deleteMethod.definition.url
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Location\DeleteLocationController::deleteMethod
* @see app/Http/Controllers/Location/DeleteLocationController.php
* @route '/api/location/{location}'
*/
deleteMethod.delete = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Location\DeleteLocationController::undo
* @see app/Http/Controllers/Location/DeleteLocationController.php
* @route '/api/location/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/location/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Location\DeleteLocationController::undo
* @see app/Http/Controllers/Location/DeleteLocationController.php
* @route '/api/location/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Location\DeleteLocationController::undo
* @see app/Http/Controllers/Location/DeleteLocationController.php
* @route '/api/location/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Location\DeleteLocationController::undo
* @see app/Http/Controllers/Location/DeleteLocationController.php
* @route '/api/location/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteLocationController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteLocationController